var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionButtonEditVisibility(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.689,
    height: 17.463,
    viewBox: "0 0 15.689 17.463",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9672",
    "data-name": "Group 9672",
    transform: "translate(-1439.392 -463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13714",
    "data-name": "Path 13714",
    d: "M2324.9,12586.962s-.326-7.338,7.337-7.338,7.338,7.338,7.338,7.338Z",
    transform: "translate(-885 -12106.999)",
    fill: "none",
    stroke: "#4d4d4d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_497",
    "data-name": "Ellipse 497",
    transform: "translate(1443 463)",
    fill: "none",
    stroke: "#4d4d4d",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7226",
    "data-name": "Rectangle 7226",
    width: 2.899,
    height: 5.786,
    transform: "translate(1450.771 471.291) rotate(43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13715",
    "data-name": "Path 13715",
    d: "M2340.668,12573.723l2.286,2.044,5.937-6.742",
    transform: "translate(-896 -12098)",
    fill: "none",
    stroke: "#4d4d4d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionButtonEditVisibility);
export default __webpack_public_path__ + "static/media/action_button_edit_visibility.db73baa318e846810242316fdf850b4e.svg";
export { ForwardRef as ReactComponent };